<template>
  <div class="ma-5">
    <div class="text-subtitle-1">Actualizar contraseña</div>
    <div class="text-caption">A continuación, actualiza tu contraseña de acceso al sistema.</div>

    <v-row>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Contraseña actual</div>
        <v-text-field v-model="password.old" density="compact" placeholder="Actual" variant="outlined"
        :append-inner-icon="pwd1 ? 'mdi-eye-off' : 'mdi-eye'"
        :type="pwd1 ? 'text' : 'password'"
        :error-messages="v$.old.$errors.map(e => e.$message)"
        @click:append-inner="pwd1 = !pwd1"/>
      </v-col>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Nueva contraseña</div>
        <v-text-field v-model="password.new" density="compact" placeholder="Nueva" variant="outlined"
        :append-inner-icon="pwd2 ? 'mdi-eye-off' : 'mdi-eye'"
        :type="pwd2 ? 'text' : 'password'"
        :error-messages="v$.new.$errors.map(e => e.$message)"
        @click:append-inner="pwd2 = !pwd2"/>
      </v-col>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Confirma la nueva contraseña</div>
        <v-text-field v-model="password.confirm" density="compact" placeholder="Confirmar" variant="outlined"
        :append-inner-icon="pwd3 ? 'mdi-eye-off' : 'mdi-eye'"
        :type="pwd3 ? 'text' : 'password'"
        :error-messages="v$.confirm.$errors.map(e => e.$message)"
        @click:append-inner="pwd3 = !pwd3"/>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn variant="flat" color="warning" text="Actualizar Contraseña" @click="update"/>
    </div>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>

    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">success</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="success.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
    
    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import { ref, reactive, computed } from 'vue';
  import { useVuelidate } from '@vuelidate/core';
  import { required, helpers } from '@vuelidate/validators'
  import axios from 'axios';
  import Params from '@/models/params';

  const password = reactive({
    old: null,
    new: null,
    confirm: null
  })

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const process = ref(false)
  const pwd1 = ref(false)
  const pwd2 = ref(false)
  const pwd3 = ref(false)

  const customRules = (value) => value == password.new;
  const rules = computed(() => {
    return{
      old: { required: helpers.withMessage('Campo requerido.', required) },
      new: { required: helpers.withMessage('Campo requerido.', required) },
      confirm: { 
        required: helpers.withMessage('Campo requerido.', required), 
        customRules: helpers.withMessage('La nueva contraseña no coincide.', customRules) }
    }
  })

  const v$ = useVuelidate(rules, password)

  const params = ref(new Params)

  async function update(){
    if(!await v$.value.$validate()){
      return
    }
    process.value = true;
    const frm = new FormData;
		frm.append("action", "changepassword");
    frm.append("data", JSON.stringify(password));
    frm.append("document", localStorage.document);
    frm.append("token", localStorage.tokenaccess);
    let result = await eject(frm);
    password.old = null;
    password.new = null;
    password.confirm = null;
    process.value = false;
    v$.value.$reset();
    if(result.status){
      success.text = result.message;
      success.state = true;
    }else{
      error.text = 'Error al intentar cambiar la contraseña.';
      error.state = true;
    }
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

</script>